exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-text-field[data-v-eb65b746] {\n  padding-top: 0 !important;\n  margin-top: 0 !important;\n}\n.v-list-item__action[data-v-eb65b746] {\n  margin-left: 0 !important;\n  display: contents !important;\n}\n.v-list-item[data-v-eb65b746]{\n  padding-right: 0 !important;\n}\n.v-input[data-v-eb65b746]{\n  flex: none !important;\n}\n.v-badge[data-v-eb65b746] {\n  left: -16px !important;\n}\n", ""]);

// exports
